export default "__VITE_ASSET__BRLMwG6J__"